import { commonBlocks } from './common';
import { homeBlocks } from './home';
import { newInsightsBlocks } from './newInsights';
import { caseStudiesBlocks } from './caseStudies';
import { vitalPointBlocks } from './vitalPoint';
import { outcomeNumbersBlocks } from './outcomeNumbers';
import { proposalInsightsBlocks } from './proposalInsights';

export const hartfordBlocks: any[] = [
  ...commonBlocks,
  ...homeBlocks,
  ...newInsightsBlocks,
  ...caseStudiesBlocks,
  ...vitalPointBlocks,
  ...outcomeNumbersBlocks,
  ...proposalInsightsBlocks,
  {
    name: 'hartford/Layout',
    partial: '',
    css: null,
  },
];
